import React, { useEffect } from 'react'
import styles from './CommonHeader.module.scss'
import LogoWorks from '../../../../../../assets/images/spa/common/logo_works.svg'
import LogoAgent from '../../../../../../assets/images/spa/common/logo_agent.svg'
import LogoTech from '../../../../../../assets/images/spa/common/logo_tech.svg'

export const StyledCommonHeader: React.FC = () => {
  const BREAKPOINT = 1280
  const activeStyle = styles.is_active

  // スライドアニメーション関数はそのまま
  const slideUp = (el: HTMLElement, duration = 300) => {
    el.style.height = el.offsetHeight + "px";
    el.offsetHeight;
    el.style.transitionProperty = "height, margin, padding";
    el.style.transitionDuration = duration + "ms";
    el.style.transitionTimingFunction = "ease";
    el.style.overflow = "hidden";
    el.style.height = "0";
    el.style.paddingTop = "0";
    el.style.paddingBottom = "0";
    el.style.marginTop = "0";
    el.style.marginBottom = "0";
    setTimeout(() => {
      el.style.display = "none";
      el.style.removeProperty("height");
      el.style.removeProperty("padding-top");
      el.style.removeProperty("padding-bottom");
      el.style.removeProperty("margin-top");
      el.style.removeProperty("margin-bottom");
      el.style.removeProperty("overflow");
      el.style.removeProperty("transition-duration");
      el.style.removeProperty("transition-property");
      el.style.removeProperty("transition-timing-function");
      el.classList.remove(activeStyle);
    }, duration);
  };

  const slideDown = (el: HTMLElement, duration = 300) => {
    el.classList.add(activeStyle);
    el.style.removeProperty("display");
    let display = window.getComputedStyle(el).display;
    if (display === "none") {
      display = "block";
    }
    el.style.display = display;
    let height = el.offsetHeight;
    el.style.overflow = "hidden";
    el.style.height = "0";
    el.style.paddingTop = "0";
    el.style.paddingBottom = "0";
    el.style.marginTop = "0";
    el.style.marginBottom = "0";
    el.offsetHeight;
    el.style.transitionProperty = "height, margin, padding";
    el.style.transitionDuration = duration + "ms";
    el.style.transitionTimingFunction = "ease";
    el.style.height = height + "px";
    el.style.removeProperty("padding-top");
    el.style.removeProperty("padding-bottom");
    el.style.removeProperty("margin-top");
    el.style.removeProperty("margin-bottom");
    setTimeout(() => {
      el.style.removeProperty("height");
      el.style.removeProperty("overflow");
      el.style.removeProperty("transition-duration");
      el.style.removeProperty("transition-property");
      el.style.removeProperty("transition-timing-function");
    }, duration);
  };

  // useEffectで副作用・イベントリスナーを管理
  useEffect(() => {
    const accordions = document.querySelectorAll(".js-headerNav");
    const accordionsArr = Array.prototype.slice.call(accordions);
    const mediaQuery = window.matchMedia(`(min-width: ${BREAKPOINT}px)`);

    // イベントハンドラ定義
    const handleTabClick = (e: Event) => {
      const clickedTrigger = (e.target as HTMLElement).closest('.js-headerTab');
      if (!clickedTrigger) return;

      const accordionTriggers = document.querySelectorAll(".js-headerTab");
      const accordionTriggersArr = Array.prototype.slice.call(accordionTriggers);
      if (window.innerWidth < BREAKPOINT && !clickedTrigger.classList.contains(activeStyle)) {
        accordionTriggersArr.forEach((otherTrigger: HTMLElement) => {
          if (otherTrigger !== clickedTrigger) {
            otherTrigger.classList.remove(activeStyle);
            otherTrigger.setAttribute('aria-expanded', 'false');
          }
        });
      } else if (window.innerWidth >= BREAKPOINT) {
        accordionTriggersArr.forEach((otherTrigger: HTMLElement) => {
          if (otherTrigger !== clickedTrigger) {
            otherTrigger.classList.remove(activeStyle);
            otherTrigger.setAttribute('aria-expanded', 'false');
          }
        });
      }

      const index = accordionTriggersArr.indexOf(clickedTrigger);
      const currentGroupNum = index + 1;
      const currentGroup = document.querySelector(`.js-headerGroup.group0${currentGroupNum}`);
      const allGroups = document.querySelectorAll(".js-headerGroup");

      if (window.innerWidth >= BREAKPOINT) {
        allGroups.forEach((group: HTMLElement) => {
          if (group !== currentGroup) {
            group.classList.remove(activeStyle);
            slideUp(group);
          }
        });

        clickedTrigger.classList.toggle(activeStyle);
        const isExpanded = clickedTrigger.classList.contains(activeStyle);
        clickedTrigger.setAttribute('aria-expanded', isExpanded.toString());

        if (currentGroup) {
          if (isExpanded) {
            currentGroup.classList.add(activeStyle);
            slideDown(currentGroup as HTMLElement);
          } else {
            currentGroup.classList.remove(activeStyle);
            slideUp(currentGroup as HTMLElement);
          }
        }
      } else {
        if (!clickedTrigger.classList.contains(activeStyle)) {
          clickedTrigger.classList.add(activeStyle);
          clickedTrigger.setAttribute('aria-expanded', 'true');
          allGroups.forEach((group: HTMLElement) => {
            if (group !== currentGroup) {
              group.classList.remove(activeStyle);
              slideUp(group);
            }
          });
          if (currentGroup) {
            currentGroup.classList.add(activeStyle);
            slideDown(currentGroup as HTMLElement);
          }
        }
      }
    };

    const handleMenuClick = () => {
      const headerMenu = document.querySelector(".js-headerMenu");
      const headerNav = document.querySelector(".js-headerNav");
      const firstTab = document.querySelector(".js-headerTab");
      const firstGroup = document.querySelector(".js-headerGroup.group01");
      const isActiveElements = document.querySelectorAll(".is-active")
      const jsHeaderGroup = document.querySelectorAll(".js-headerGroup")

      if (!headerMenu || !headerNav || !firstTab || !firstGroup) return;

      headerMenu.classList.toggle(activeStyle);
      const isExpanded = headerMenu.classList.contains(activeStyle);
      headerMenu.setAttribute('aria-expanded', isExpanded.toString());

      if (isExpanded) {
        headerNav.classList.add(activeStyle);
        firstTab.classList.add(activeStyle);
        firstTab.setAttribute('aria-expanded', 'true');
        firstGroup.classList.add(activeStyle);
        slideDown(headerNav as HTMLElement);
        slideDown(firstGroup as HTMLElement);

        accordionsArr.forEach((accordion: HTMLElement) => {
          const accordionTriggers = accordion.querySelectorAll(".js-headerTab");
          const accordionTriggersArr = Array.prototype.slice.call(accordionTriggers);
          accordionTriggersArr.forEach((trigger: HTMLElement) => {
            trigger.addEventListener("click", handleTabClick);
          });
        });
      } else {
        headerNav.classList.remove(activeStyle);
        firstTab.classList.remove(activeStyle);
        firstTab.setAttribute('aria-expanded', 'false');
        firstGroup.classList.remove(activeStyle);
        slideUp(headerNav as HTMLElement);
        slideUp(firstGroup as HTMLElement);

        accordionsArr.forEach((accordion: HTMLElement) => {
          const accordionTriggers = accordion.querySelectorAll(".js-headerTab");
          const accordionTriggersArr = Array.prototype.slice.call(accordionTriggers);
          accordionTriggersArr.forEach((trigger: HTMLElement) => {
            trigger.removeEventListener("click", handleTabClick);
          });
        });
        isActiveElements.forEach((element: HTMLElement) => {
          handleHeaderMenu(element);
        });
        jsHeaderGroup.forEach((element: HTMLElement) => {
          handleMenuGroup(element);
        });
      }
    };

    const handleHeaderMenu = (element: any) => {
      element.classList.remove(activeStyle);
    };

    const handleMenuGroup = (element: any) => {
      slideUp(element);
    };

    const handleMediaQueryChange = (e: MediaQueryListEvent | MediaQueryList) => {
      const headerMenu = document.querySelector(".js-headerMenu");
      const headerNav = document.querySelector(".js-headerNav");

      if (e.matches) {
        accordionsArr.forEach((accordion: HTMLElement) => {
          const accordionTriggers = accordion.querySelectorAll(".js-headerTab");
          const accordionTriggersArr = Array.prototype.slice.call(accordionTriggers);
          accordionTriggersArr.forEach((trigger: HTMLElement) => {
            trigger.addEventListener("click", handleTabClick);
          });
        });

        if (headerMenu && headerNav) {
          headerMenu.removeEventListener("click", handleMenuClick);
        }
      } else {
        if (headerMenu && headerNav) {
          headerMenu.addEventListener("click", handleMenuClick);
        }

        accordionsArr.forEach((accordion: HTMLElement) => {
          const accordionTriggers = accordion.querySelectorAll(".js-headerTab");
          const accordionTriggersArr = Array.prototype.slice.call(accordionTriggers);
          accordionTriggersArr.forEach((trigger: HTMLElement) => {
            trigger.removeEventListener("click", handleTabClick);
          });
        });
      }
    };

    // 初期化
    handleMediaQueryChange(mediaQuery);
    mediaQuery.addEventListener("change", handleMediaQueryChange);

    // リサイズイベント
    const handleResize = () => {
      const headerMenu = document.querySelector(".js-headerMenu");
      const headerNav = document.querySelector(".js-headerNav");
      const tabs = document.querySelectorAll(".js-headerTab");
      const groups = document.querySelectorAll(".js-headerGroup");

      if (headerMenu) {
        headerMenu.classList.remove(activeStyle);
        headerMenu.setAttribute('aria-expanded', 'false');
      }
      if (headerNav) {
        headerNav.classList.remove(activeStyle);
        headerNav.style.display = window.innerWidth >= BREAKPOINT ? 'block' : 'none';
      }
      tabs.forEach(tab => {
        tab.classList.remove(activeStyle);
        tab.setAttribute('aria-expanded', 'false');
      });
      groups.forEach(group => {
        group.classList.remove(activeStyle);
        (group as HTMLElement).style.display = 'none';
      });
    };
    window.addEventListener('resize', handleResize);

    // クリーンアップ
    return () => {
      mediaQuery.removeEventListener("change", handleMediaQueryChange);
      window.removeEventListener('resize', handleResize);
      accordionsArr.forEach((accordion: HTMLElement) => {
        const accordionTriggers = accordion.querySelectorAll(".js-headerTab");
        const accordionTriggersArr = Array.prototype.slice.call(accordionTriggers);
        accordionTriggersArr.forEach((trigger: HTMLElement) => {
          trigger.removeEventListener("click", handleTabClick);
        });
      });
      const headerMenu = document.querySelector(".js-headerMenu");
      if (headerMenu) {
        headerMenu.removeEventListener("click", handleMenuClick);
      }
    };
  }, []);

  // JSX部分はそのまま
  return (
    <header className={`${styles.commonHeader}`}>
      <div className='commonHeader__inner'>
        <div className={`${styles.commonHeader__tab}`}>
          <div className={`${styles.commonHeader__tabBtn} js-headerMenu`} aria-expanded="false"></div>
          <nav className={`${styles.commonHeader__tabNav} js-headerNav`}>
            <ul className={`${styles.commonHeader__tabList}`}>
              <li className={`${styles.commonHeader__tabItem} js-headerTab tab01`} aria-label="フリーランスとして働きたい方" aria-expanded="false">
                <button className={`${styles.commonHeader__tabText}`}>フリーランスとして<br />働きたい方</button>
              </li>
              <li className={`${styles.commonHeader__tabItem} js-headerTab tab02`} aria-label="フリーランスを探したい方" aria-expanded="false">
                <button className={`${styles.commonHeader__tabText}`}>フリーランスを<br />さがしたい方</button>
              </li>
            </ul>
          </nav>
        </div>
        <div className='commonHeader__cont js-headerCont'>
          <div className={`${styles.commonHeader__tabGroup} js-headerGroup group01`}>
            <div className={`${styles.groupCont}`}>
              <div className={`${styles.groupCont__cont}`}>
                <p className={`${styles.groupCont__title}`}>自分でさがしたい</p>
                <div className={`${styles.groupCont__item}`}>
                  <a href="https://crowdworks.jp/for-employee?ref=brandheader_link01&tracking=brandheader_link01&utm_source=crowdtech.jp&utm_medium=referral&utm_content=jp_wk_brandheader01" className={`${styles.groupCont__link}`}>
                    <p>自分にあった仕事をさがす</p>
                    <img src={LogoWorks} alt="クラウドワークス" />
                  </a>
                </div>
              </div>
              <div className={`${styles.groupCont__cont}`}>
                <p className={`${styles.groupCont__title}`}>代わりにさがしてほしい</p>
                <div className={`${styles.groupCont__item}`}>
                  <a href="https://crowdtech.jp/?ref=brandheader_link02&tracking=brandheader_link02&utm_source=crowdtech.jp&utm_medium=referral&utm_content=cwt_brandheader02" className={`${styles.groupCont__link}`}>
                    <p>ITフリーランス向けの仕事を<br />さがしてもらう</p>
                    <img src={LogoTech} alt="クラウドワークス テック" />
                  </a>
                </div>
                <div className={`${styles.groupCont__item}`}>
                  <a href="https://crowdworks.jp/static/lp/bizassistant_online/?ref=brandheader_link03&tracking=brandheader_link03&utm_source=crowdtech.jp&utm_medium=referral&utm_content=ba_wk_brandheader03" className={`${styles.groupCont__link}`} target="_blank">
                    <p>バックオフィスの仕事を<br />さがしてもらう</p>
                    <img src={LogoWorks} alt="クラウドワークス" />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className={`${styles.commonHeader__tabGroup} js-headerGroup group02`}>
            <div className={`${styles.groupCont}`}>
              <div className={`${styles.groupCont__cont}`}>
                <p className={`${styles.groupCont__title}`}>自分でさがしたい</p>
                <div className={`${styles.groupCont__item}`}>
                  <a href="https://crowdworks.jp/?ref=brandheader_link04&tracking=brandheader_link04&utm_source=crowdtech.jp&utm_medium=referral&utm_content=jp_cl_brandheader04" className={`${styles.groupCont__link}`}>
                    <p>全国のフリーランスに<br />仕事を依頼する</p>
                    <img src={LogoWorks} alt="クラウドワークス" />
                  </a>
                </div>
              </div>
              <div className={`${styles.groupCont__cont}`}>
                <p className={`${styles.groupCont__title}`}>代わりにさがしてほしい</p>
                <div className={`${styles.groupCont__item}`}>
                  <a href="https://agent.crowdworks.jp/?ref=brandheader_link05&tracking=brandheader_link05&utm_source=crowdtech.jp&utm_medium=referral&utm_content=cwa_brandheader05" className={`${styles.groupCont__link}`}>
                    <p>即戦力のフリーランスを<br />さがしてもらう</p>
                    <img src={LogoAgent} alt="クラウドワークス エージェント" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}
